module.exports = __webpack_public_path__ + "img/rule3.4151bb33.jpg";